import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FileImage = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='m4 16 3.293-3.293a1 1 0 0 1 1.414 0L12 16l1.293-1.293a1 1 0 0 1 1.414 0L19 19M6 20h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.25 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M14.25 7.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.25 6A2.75 2.75 0 0 1 6 3.25h12A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18zm15.988 12.177q.012-.087.012-.177V6c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v8.19l2.013-2.013a1.75 1.75 0 0 1 2.474 0L12 14.939l.763-.762a1.75 1.75 0 0 1 2.474 0z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
